import Animation from "../classes/Animation";

import gsap from 'gsap';

export default class Label extends Animation {
    constructor({ element }){
        super({
            element
        })
    }

    animateIn(){
        this.timelineIn = gsap.timeline({
            delay: .5, 
        });

        this.timelineIn.set(this.element, {
            autoAlpha: 1
        })

        this.timelineIn.fromTo(this.element, {
            autoAlpha: 0,
        },{
            duration: 2,
            ease: 'expo.out',
            autoAlpha: 1,
        }, 0)
    }

    animateOut(){
        gsap.set(this.element, {
            autoAlpha: 0
        })
    }
}